import { ReactNode } from 'react';

import { ChartGraphic } from '../ChartGraphic';

import styles from './ChartBackground.module.css';

export const ChartBackground = ({ children }: { children: ReactNode }) => (
  <div className={styles.root}>
    <ChartGraphic className={styles.chart} />
    {children}
  </div>
);
